import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { memo } from 'react';

import {
  RagChatCustomData,
  RagChatMessageItem,
  RagChatReferenceItem,
  Source,
  isChatHistoryId,
} from '../../../domain/ragChat/types';

import { parseNumber } from '../../../utils/parseNumber';
import { MessageItem } from './MessageItem';

// --- LoadingMessage ---
const LoadingMessage = memo(() => (
  <Box>
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
      }}
    >
      <AutoAwesomeIcon sx={{ fontSize: '1rem' }} />
      <Box
        sx={{
          ml: 1,
          fontSize: '0.8rem',
        }}
      >
        応答中...
      </Box>
    </Box>
    <Skeleton variant="text" sx={{ borderRadius: 2 }} />
    <Skeleton variant="text" sx={{ borderRadius: 2, width: '18em' }} />
    <Skeleton variant="text" sx={{ borderRadius: 2, width: '10em' }} />
  </Box>
));

// --- MessageList ---
export const MessageList = memo(
  ({
    messages,
    status,
    data,
  }: {
    messages: RagChatMessageItem[];
    status: 'submitted' | 'streaming' | 'ready' | 'error';
    data: RagChatCustomData[] | undefined;
  }) => {
    return (
      <Box display="flex" flexDirection="column" gap={2} mt={0}>
        {messages.map((message, index) => {
          const reference_documents: RagChatReferenceItem[] = message.parts
            .filter((part): part is Source => part.type === 'source')
            .map((part) => ({
              title: part.source.title ?? '',
              url: part.source.url,
              marker: parseNumber(part.source.id),
            }));

          const annotation = message.annotations?.at(0);
          const chatHistoryId =
            annotation !== undefined && isChatHistoryId(annotation)
              ? annotation.chatHistoryId
              : undefined;

          const customData =
            data?.find((d) => d.chatHistoryId === chatHistoryId) ?? null;

          const isLatest = index === messages.length - 1;
          return (
            <MessageItem
              key={message.id}
              role={message.role}
              content={message.content}
              id={message.id}
              isNew={isLatest && status === 'ready'}
              isLatest={isLatest}
              status={status}
              customData={customData}
              reference_documents={reference_documents}
              chatHistoryId={chatHistoryId}
            />
          );
        })}
        {status === 'submitted' ? <LoadingMessage /> : null}
      </Box>
    );
  }
);
